import React from 'react'
import {View, FieldsGroup, ButtonFields,SelectField} from 'react-template'
import {recuperarDadosCertificadoDaSubmissao} from '../../view/formulario/actions/FormBuilderActions'
import {liberarCertificadoUnido, atualizarCertificadoUnido, downloadCertificado} from '../../view/formulario/actions/FormActions'
import {downloadFileLink} from "../../helpers/Downloads"
export default class Certificados extends View {

    constructor(props) {
      super(props)
    
      this.state = {
        submissoes: []
      }
    }
    

    componentDidMount = () => {
        // let itensId = this.props.itensComCertificado.map(i => {
        //     return i.itemId
        // })
        recuperarDadosCertificadoDaSubmissao(this.props.idSubmissao, res => {
            this.setState({submissoes: res.data})
        }, error => {
            this.notifyError("Erro", error)
        })
    }

    findCampo(idCampo){
        return this.props.camposComCertificado.find(c => {
            return c.item.id === parseInt(idCampo, 10) 
        })
    }

    findModelosCertificado(idCampo){
        if(this.props.todosModelosDeCertificado){
            let modelos = this.props.todosModelosDeCertificado.filter(m => {
                return m.idCampo === parseInt(idCampo, 10) 
            })
    
            return modelos
        }
        return []
    }

    findSubmissao(idCampo){
        idCampo = parseInt(idCampo, 10)
        return this.state.submissoes.find(s => {
            return s.idCampo === idCampo
        })
    }

    getQuestaoIndex(idCampo){
        try {
            const campo = this.findCampo(idCampo)
            return `questao_${campo.item.id}`
        } catch (error) {  }
    }

    imprimirLinhaDeCertificado( resposta, itemId = 0, titulo = '' ){
        
        if(!this.props.pesquisa_submissao){
            const options = this.findModelosCertificado(itemId).map(m => {
                return this.createObjectCombo(`modelo_${m.id}`, m.tituloModelo)
            })
    
            const questaoIndex = this.getQuestaoIndex(itemId)
            
            return (
                <div>
                    <b>{resposta}</b> <br />
                    <small>{titulo}</small>

                    <div>
                        {!this.props.pesquisa_submissao && (
                            this.renderLiberarCertificadoForm(questaoIndex, options)
                        )}
                    </div>
                </div>
            )
        } else {
            return (
                <tr>
                    <td>
                        <b>{resposta}</b> <br />
                        <small>{titulo}</small>
                    </td>
                    <td>
                        {this.getDownloadButton(itemId)}
                    </td>
                </tr>

            )
        }
    }

    getDownloadButton(idCampo){

        const dados = this.findSubmissao(idCampo)

        if(dados != null){
            return (
                <ButtonFields button='flat' color='blue' icon='file_download' onClick={(idCampo) => this.downloadCertificado(dados.id)} content='Download'/>
            )
        }

        return (
            <span>Certificado não liberado.</span>
        )
    }

    downloadCertificado(idDadoCertificado){
        this.props.changeStatusLoader()
        downloadCertificado(idDadoCertificado, res => {
            downloadFileLink(res.data, "Certificado")
            this.props.changeStatusLoader()
        }, error => {
            this.notifyError("Erro", error)
            this.props.changeStatusLoader()
        })
    }
    
    getValue(name){
        try {
            
            if(this.state[name]) return this.state[name]
            
            const idCampo = parseInt(name.split("_")[1], 10)

            const sub = this.state.submissoes.find(s => {
                return s.idCampo === idCampo
            })

            if(sub !== undefined && sub != null){
                return `modelo_${sub.modeloCertificado.id}`
            } 

        } catch (error) {}

        return ""
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    onSubmit = (e, name) => {
        e.preventDefault()
        const idCampo = parseInt(name.split("_")[1], 10)
        const idModelo = parseInt(this.state[name].split("_")[1], 10)
        let data = {
            idSubmissao: this.props.idSubmissao,
            idCampo,
            idModelo
        } 

        if(this.findSubmissao(idCampo)){
            atualizarCertificadoUnido(data, res => {
                let submissoes = this.state.submissoes.filter(s => {
                    return s.idCampo !== idCampo
                })
                submissoes.push(res.data)
                this.setState({submissoes})
                this.notifySucess("Certificado atualizado com Sucesso.")
            }, error => {
                this.notifyError("Erro", error)
            })
        } else {
            liberarCertificadoUnido(data, res => {
                let submissoes = this.state.submissoes
                submissoes.push(res.data)
                this.setState({submissoes})
                this.notifySucess("Certificado liberado com Sucesso.")
            }, error => {
                this.notifyError("Erro", error)
            })
        }
    }

    desabilitarBotaoDeSalvar(name){
        const idCampo = parseInt(name.split("_")[1], 10)
        const submissao = this.findSubmissao(idCampo)
        if(this.state[name]){
            if(submissao && `modelo_${submissao.modeloCertificado.id}` === this.state[name]){
                return true
            }
            return false
        }

        return true
    }

    renderLiberarCertificadoForm(name, opcoes){

        if(opcoes.length > 0)
            return (
                <FieldsGroup>
                    <SelectField required invalidMessage="O campo é de preenchimento obrigatório"
                        value={this.getValue(name)}
                        name={name} 
                        label='Modelo de Certificado' 
                        placeholder='Selecione um Campo'
                        options={opcoes}
                        onChange={this.handleChange.bind(this)}
                        width={10}
                    />
                    <ButtonFields button='colored' color="blue" type="submit" content="Salvar" disabled={this.desabilitarBotaoDeSalvar(name)} onClick={(e) => this.onSubmit(e, name)}/> 
                </FieldsGroup>
            ) 
        
        
        return (
            <span>Nenhum modelo cadastrado para esse Campo.</span>
        )
    }
    
    imprimir(){
        if(!this.props.pesquisa_submissao){
            return (
                <div>
                    { this.props.tem_presenca && (
                            this.imprimirLinhaDeCertificado('Certificado do Evento')
                        )}
                    {
                        this.props.itensComCertificado.map(item => (
                            this.imprimirLinhaDeCertificado( item.resposta, item.itemId ,item.titulo)
                        ))
                    }
                </div>
                )
        }

        return (
            <table className='table-certificado'>
                <thead>
                    <tr>
                        <th className='p-t'>Titulo</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    { this.props.tem_presenca && (
                            this.imprimirLinhaDeCertificado('Certificado do Evento')
                        )}
                    {
                        this.props.itensComCertificado.map(item => (
                            this.imprimirLinhaDeCertificado( item.resposta, item.itemId ,item.titulo)
                        ))
                    }
                </tbody>
            </table>
        )
    }

    render() {
        return (
            this.imprimir()
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/view/Certificados.js